import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';

// Initialize Firebase
const config = {
    apiKey: `${process.env.VUE_APP_FIREBASE_API_KEY}`, // war eigentlich ohne Anführungszeichen
    authDomain: `${process.env.VUE_APP_FIREBASE_AUTH_DOMAIN}`,
    storageBucket: `${process.env.VUE_APP_FIREBASE_STORAGE_BUCKET}`,
    databaseURL: `${process.env.VUE_APP_FIREBASE_DB_URL}`, // war eigentlich ohne Anführungszeichen
    projectId: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}`,
    messagingSenderId: `${process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID}`,
    appId: `${process.env.VUE_APP_FIREBASE_APP_ID}`,
    measurementId: `${process.env.VUE_APP_FIFREBASE_MEASUREMENT_ID}`,
};
// console.log('config:', config)
if (firebase.apps.length === 0) {
    firebase.initializeApp(config);
    // firebase.firestore().settings({ experimentalForceLongPolling: true });
    if (process.env.NODE_ENV === 'production') {
        firebase.analytics();
    }
}
// firebase.initializeApp(config);
// console.log('firebase:', firebase)
// https://mherman.org/blog/node-grpc-postgres/#grpc

// const firestore = firebase.firestore();
// const settings = {/* your settings... */
//     // timestampsInSnapshots: true
// };
// firestore.settings(settings);

const db = firebase.firestore();
const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);
const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();
const timestamp = firebase.firestore.Timestamp;
// //für Bilder
// var storage = firebase.storage().ref();

// const db = firebaseApp.database()
export {
    config,
    db,
    increment,
    decrement,
    serverTimestamp,
    timestamp,
};
// export default storage
